import Butter from "buttercms";
export const butter = Butter("74d935a7eba2b070f764de8bce1afde36afb32d6");
